/* Mobile filtering is committed as one server-side Shopify request; tags use AND semantics. */
document.addEventListener('click', event => {
  const reset = event.target.closest('[data-bc-mobile-reset]');
  if (reset) {
    event.preventDefault(); event.stopPropagation();
    const form = reset.closest('form');
    form.querySelectorAll('input[type=checkbox]').forEach(input => { input.checked = false; });
    form.querySelectorAll('price-range input').forEach(input => { input.value = ''; });
    form.querySelectorAll('bc-price-chips button').forEach(button => button.setAttribute('aria-pressed', String(!button.dataset.min && !button.dataset.max)));
    return;
  }
  const cancel = event.target.closest('[data-bc-mobile-cancel]');
  if (cancel) { event.preventDefault(); event.stopPropagation(); cancel.closest('form').reset(); cancel.closest('menu-drawer').querySelector('summary').click(); return; }
  const apply = event.target.closest('[data-bc-mobile-apply]');
  if (!apply) return;
  event.preventDefault(); event.stopPropagation();
  const form = apply.closest('form');
  if (!form.reportValidity()) return;
  const url = new URL(location.href);
  const tags = form.querySelector('bc-tag-filters');
  if (tags) {
    const previous = location.pathname.slice(tags.dataset.collectionUrl.length).replace(/^\//, '').split('+').filter(Boolean).map(decodeURIComponent);
    const listed = new Set([...tags.querySelectorAll('[data-bc-tag]')].map(input => input.value));
    const selected = previous.filter(tag => !listed.has(tag));
    tags.querySelectorAll('[data-bc-tag]:checked').forEach(input => selected.push(input.value));
    url.pathname = tags.dataset.collectionUrl + (selected.length ? '/' + selected.map(encodeURIComponent).join('+') : '');
  }
  [...url.searchParams.keys()].forEach(key => { if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key); });
  for (const [key, value] of new FormData(form)) {
    if (!value) continue;
    if (key.startsWith('filter.')) url.searchParams.append(key, value);
    else url.searchParams.set(key, value);
  }
  location.assign(url.href);
}, true);
if (!customElements.get('bc-page-jump')) customElements.define('bc-page-jump', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    this.hidden = false;
    this.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      const input = this.querySelector('input');
      if (!input.reportValidity()) return;
      const url = new URL(location.href);
      url.searchParams.set('page', input.value);
      url.hash = 'ProductGridContainer';
      location.assign(url.href);
    });
  }
});
if (!customElements.get('bc-price-chips')) customElements.define('bc-price-chips', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    this.hidden = false;
    this.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button) return;
      const inputs = this.closest('price-range').querySelectorAll('input');
      inputs[0].value = button.dataset.min || '';
      inputs[1].value = button.dataset.max || '';
      this.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      inputs[1].dispatchEvent(new Event('change', { bubbles: true }));
      inputs[1].dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
});
